exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/learning-assistant-chat-ai.js-WebpackMultiOutput";